import { languageMenuStyles } from "@insite/content-library/Widgets/Common/LanguageMenu";
import { FormFieldIcon } from "@insite/mobius/FormField";
import { mediaOptions } from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import { TYPOGRAPHY } from "@store/theme/common/design";
import breakpointValuesMediaQueries from "@store/utilities/breakpointValuesMediaQueries";
import { css } from "styled-components";

Object.assign(languageMenuStyles, {
    languageSelect: {
        backgroundColor: "transparent",
        cssOverrides: {
            formInputWrapper: css`
                width: auto;
                align-self: flex-end;

                ${({ theme }) => {
                    return breakpointValuesMediaQueries(
                        theme,
                        [{ values: [15, null, null, 50, null], properties: ["margin-right"], unit: "px" }],
                        mediaOptions.min,
                    );
                }}

                ${FormFieldIcon} {
                    position: absolute;
                    top: 0;
                    right: 0;
                    bottom: 0;
                    width: 18px;
                    padding: 0;
                    margin: auto 0;
                    color: ${getColor("primary.contrast")};
                }
            `,
            inputSelect: css`
                padding-right: 23px;
                border: 2px solid transparent;
                color: ${getColor("primary.contrast")};
                font-size: ${TYPOGRAPHY.size.smaller};
                font-weight: ${TYPOGRAPHY.weight.medium};
                text-transform: uppercase;
                cursor: pointer;

                &:focus {
                    padding-right: 24px;
                }

                option {
                    color: ${getColor("secondary")};
                }
            `,
        },
    },
});
